import type { StoryObj } from '@storybook/html'
import type { CobaltNotificationPill as CobaltNotificationPillProps } from './cobalt-notification-pill'

export default {
  title: 'Components/Feedback/cobalt-notification-pill',
  argTypes: {
    number: {
      type: { name: 'string' },
      description: 'The number inside the pill.',
      table: {
        type: { summary: 'string' }
      }
    }
  }
}

const Template = (args: CobaltNotificationPillProps) => {
  return `<cobalt-notification-pill number="${args.number}"></cobalt-notification-pill>`
}

export const Default: StoryObj = Template.bind({})

Default.args = {
  number: undefined
}
